import DIVISOR from '../constants/divisor';
import cloneDeep from 'lodash.clonedeep';

export const sizeTemplate = {
  axes: {
    shown: true,
    tickStyle: null,
    units: {
      commas: false,
      prefix: '',
      suffix: '',
      forceDecimals: undefined,
      maxDecimals: undefined,
      divisor: DIVISOR[0]
    },
    showRecessions: false,
    showUkRecessions: false,
    reversed: false,
    maxYAxisValue: undefined,
    minYAxisValue: undefined,
    maxXAxisValue: undefined,
    minXAxisValue: undefined,
    xAxisIncrementsForScatter: undefined
  },
  xAxis: {},
  yAxis: {},
  stacking: null,
  height: 0,
  width: 0,

  tooltips: {
    commas: false,
    prefix: '',
    suffix: '',
    forceDecimals: undefined,
    maxDecimals: undefined,
    divisor: DIVISOR[0],
    sameAsAxes: true,
  },

  editing: true
};

const chartTemplate = {
  title: '',
  type: null,
  product: getPublication(),

  color: {
    theme: null,
    mode: 'DEFAULT',
    threshold: 0,
    opacity: 100
  },

  targets: [],
  manualWidth: false,
  manualHeight: false,
  markdown: false,
  showCharts: true,
  groups: null,
  print: { slug: 'ok', section: 'Test' },
  step: false,

  data: {
    raw: '',
    parsed: null,
    type: null,
    showMinorTicks: true,
    showTooltips: true,
    connectEmptyDataPoints: 'solid',
    markedDataPoints: false,
    isScatterplot: false,
    categories: null,
    series: null,
    possibleCharts: [],
    tickers: [],
    frequency: 'P1D',
    dateRange: '6M',
    start: '',
    end: '',
    companies: { type: '', list: [] },
    isPercent: false,
    disableShowAsPercent: true,
    singleIsPercent: false,
    isRolling: false,
    horizontalBarType: 'normal',
    specialHorizontalBarXValue: '',
    horizontalBarLabel: true,

    // Which date/time components to not use:
    suppress: {},
  },

  sizes: {},

  admin: {
    sections: [],
    notes: '',
    approved: {
      editor: false,
      graphics: false
    }
  },

  publishedImageRatio: 0,
};


const documentTemplate = {
  // Permanent identifier assigned by the database:
  id: null,

  // Temporary identifier assigned by the app:
  documentId: null,

  status: 'draft',
  history: [],
  urls: {},

  rendering: false,
  svg: {},

  chartIo: {
    fetching: false,
    posting: false,
    error: null
  },

  rawDataIo: {
    fetching: false,
    url: null,
    error: null,
  },

  publishIo: {
    status: null,
    error: null
  },

  selectedPoint: null,

  chart: cloneDeep(chartTemplate),
  saved: null,
  dirty: false,
  invalidated: {},
  nextInvalidated: {}
};

export default documentTemplate;
